import { FunctionComponent } from "react";
import { StyledLabel } from "./label.styles";

interface LabelProps {
  children: any;
  name: string;
  className?: string;
  required?: boolean;
  disabled?: boolean;
}

const Label: FunctionComponent<LabelProps> = ({
  children,
  name,
  required,
  className,
  disabled = false,
}) => {
  return (
    <StyledLabel
      className={className}
      htmlFor={`id_${name}`}
      $disabled={disabled}
    >
      {children}
      {required && " *"}
    </StyledLabel>
  );
};

export default Label;
